import { useRouter } from 'next/router'

import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
import ROUTES from '~/shared/constants/routes.const'
import { MobileLogo } from '~/shared/layouts/components/HeaderTop/MobileLogo'
import { Logo } from '~/shared/layouts/components/HeaderTop/Logo'
import { HomeButton } from '~/shared/layouts/components/HeaderTop/components/HomeButton'
import { LeagueButton } from '~/shared/layouts/components/HeaderTop/components/LeagueButton'
import { MenuRight } from '~/shared/layouts/components/HeaderTop/components/MenuRight'

interface Props {
  className?: string
  hideAIButton?: boolean
}

const HeaderTop = ({ className = '', hideAIButton = false }: Props): React.ReactElement => {
  const authenticated = useAppSelector(isAuthenticated)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const router = useRouter()
  const isDashboard = router.pathname === ROUTES.DASHBOARD

  return (
    <header
      className={`z-header h-13 md:h-16 drop-shadow-navbar bg-purple-abyss border-0 border-b border-solid border-purple-lilac-fade ${className}`}
    >
      <div className="flex px-4 md:px-8 items-center h-full justify-between">
        <div className="flex items-center gap-6" data-ph-unmask>
          {isMobile ? <MobileLogo /> : <Logo className="w-34" white />}
          {authenticated && !isMobile && (
            <>
              {!isDashboard && <HomeButton />}
              <LeagueButton />
            </>
          )}
        </div>
        <MenuRight authenticated={authenticated} hideOracleButton={hideAIButton} />
      </div>
    </header>
  )
}

export default HeaderTop
